import { reducers } from '../generated';
import type { ConnectionManager } from '../core/ConnectionManager';
import type { ReducerClient } from '../core/ReducerClient';
import type { Logger } from '../types';

export class DungeonModule {
  constructor(
    private readonly connectionManager: ConnectionManager,
    private readonly reducerClient: ReducerClient,
    private readonly logger: Logger = () => undefined
  ) {}

  public async enterDungeon(dungeonId: string): Promise<void> {
    await this.reducerClient.callAndConfirm({
      reducerName: 'enter_dungeon',
      paramsType: reducers.enterDungeon.paramsType,
      args: { dungeonId },
      onEvent: 'onEnterDungeon',
      offEvent: 'removeOnEnterDungeon',
      timeoutMessage: 'Dungeon entry timed out',
      failureMessage: 'Failed to enter dungeon'
    });
  }
}
